import { hasMany } from '@warp-drive/legacy/model';
import DigitalAsset from './digital-asset.ts';
import type ConditionModel from './condition.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class PublicAsset extends DigitalAsset {
  @hasMany('condition', { async: false, inverse: 'publicAssets' })
  declare conditions: ConditionModel[];

  [Type] = 'public-asset' as const;
}
